import {
  AfterViewInit,
  Component,
  OnInit, ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {language} from '../../../../language/vn';
import {ToTrinhService} from '../../../../service/totrinh/service-totrinh';
import {ToTrinhXuLyService} from '../../../../service/totrinh/service-totrinhxuly';
import {YeuCauService} from '../../../../service/yeucau/service-yeucau';
import {YeuCauXuLyService} from '../../../../service/yeucau/service-yeucauxuly';
import {ThongBaoService} from '../../../../service/info/service-thongbao';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {environment} from '../../../../../environments/environment';
import {BaseChartDirective, Color} from 'ng2-charts';
import {MeetingXuLyService} from '../../../../service/info/service-meetingxuly';
import {RolePermissionService} from '../../../../service/security/service-rolepermission';

@Component({
  selector: 'egov-tonghop-giaiquyetsuvu',
  templateUrl: './tonghop.component.html',
  encapsulation: ViewEncapsulation.None
})
export class GiaiQuyetSuVuTongHopComponent implements OnInit, AfterViewInit {
  //@ViewChild(BaseChartDirective)
   //public chart: BaseChartDirective;

  public totalToTrinhXuLy: number =0;
  public totalToTrinhNhan: number =0;
  public totalToTrinhDangSoan: number =0;
  public totalYeuCauGui: number =0;
  public totalYeuCauNhan: number =0;
  public totalYeuCauDangSoan: number =0;
  public totalCuocHop:  number=0;
  public totalThongBao: number =0;
  public totalTCChuaXuLy: number=0;
  public totalTCDangXuLy: number=0;
  public totalTCHoanThanh: number=0;
  public totalTCChuaXem: number=0;
  public ty: string = '';
  public totalYCChuaXuLy: number=0;
  public totalYCDangXuLy: number=0;
  public totalYCHoanThanh: number=0;
  public totalYCChuaXem: number=0;

  public status: number[] =[
    environment.chuaxuly,
    environment.dangxuly,
    environment.hoanthanh
  ];
  public toTrinhChartLabels: string[] = [language.chuaxuly, language.dangxuly, language.hoanthanh, language.nhanchuaxem];
  public toTrinhChartData: number[] = [this.totalTCChuaXuLy, this.totalTCDangXuLy, this.totalTCHoanThanh, this.totalTCChuaXem];

  public yeuCauChartLabels: string[] = [language.chuaxuly, language.dangxuly, language.hoanthanh, language.nhanchuaxem];
  public yeuCauChartData: number[] = [this.totalYCChuaXuLy, this.totalYCDangXuLy, this.totalYCHoanThanh, this.totalYCChuaXem];

  public doughnutChartType = 'doughnut';
  public language = language;
  public chartColors: Color[] = [
    {
      backgroundColor: [
        '#fad908',
        '#0872fa',
        '#0ef20e',
        '#f22a0e'
      ]
    }
  ];
  constructor(
    public toTrinhService: ToTrinhService,
    public toTrinhXuLyService: ToTrinhXuLyService,
    public yeuCauService: YeuCauService,
    public yeuCauXuLyService: YeuCauXuLyService,
    public meetingService: MeetingXuLyService,
    public thongBaoService: ThongBaoService,
    public rolePermissionService: RolePermissionService
  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.loadTotal();
    setTimeout (() => {
      this.loadChart();
    }, 2000);
  }
  public loadChart()
  {
    this.toTrinhChartData = [this.totalTCChuaXuLy, this.totalTCDangXuLy, this.totalTCHoanThanh, this.totalTCChuaXem];
    this.yeuCauChartData = [this.totalYCChuaXuLy, this.totalYCDangXuLy, this.totalYCHoanThanh, this.totalYCChuaXem];
  }
  public loadTotal()
  {
    this.toTrinhService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, -1,'','').subscribe(recordCount => this.totalToTrinhXuLy = recordCount);
    this.toTrinhXuLyService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, -1,'','').subscribe(recordCount => this.totalToTrinhNhan = recordCount);
    this.toTrinhXuLyService.getCountByKeyword('', environment.chuaxuly.toString(), Sessioncommand.staffId, 0, '','').subscribe(recordCount => this.totalTCChuaXem = recordCount);
    this.toTrinhXuLyService.getCountByKeyword('', environment.chuaxuly.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalTCChuaXuLy = recordCount);
    this.toTrinhXuLyService.getCountByKeyword('', environment.dangxuly.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalTCDangXuLy = recordCount);
    this.toTrinhXuLyService.getCountByKeyword('', environment.hoanthanh.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalTCHoanThanh = recordCount);
    this.toTrinhService.getCountByKeyword('', environment.soanthao.toString(), Sessioncommand.staffId, -1,'','').subscribe(recordCount => this.totalToTrinhDangSoan = recordCount);
    this.yeuCauService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalYeuCauGui = recordCount);
    this.yeuCauXuLyService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, -1,'','').subscribe(recordCount => this.totalYeuCauNhan = recordCount);
    this.yeuCauXuLyService.getCountByKeyword('', environment.chuaxuly.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalYCChuaXuLy = recordCount);
    this.yeuCauXuLyService.getCountByKeyword('', environment.dangxuly.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalYCDangXuLy = recordCount);
    this.yeuCauXuLyService.getCountByKeyword('', environment.hoanthanh.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalYCHoanThanh = recordCount);
    this.yeuCauXuLyService.getCountByKeyword('', environment.chuaxuly.toString(), Sessioncommand.staffId, 0, '','').subscribe(recordCount => this.totalYCChuaXem = recordCount);
    this.yeuCauService.getCountByKeyword('',  environment.soanthao.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalYeuCauDangSoan = recordCount);
    this.meetingService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, -1).subscribe(recordCount => this.totalCuocHop = recordCount);
    this.rolePermissionService.checkPermissionByModule(Sessioncommand.staffId,"egov.info.thongbao").subscribe(
      x => {

        this.thongBaoService.getCountByKeyword('', ( x.findIndex( y => y.action === environment.xemtatca || y.action === environment.toanquyen) !== -1 ? -1 : Sessioncommand.staffId), -1).subscribe(recordCount => this.totalThongBao = recordCount);
      }
    );

  }

}

